import React from "react";
import { Slider, Typography, Box } from "@mui/material";

type Option = {
  id: number;
  text: string;
};

type PointDistributionProps = {
  question: string;
  options: Option[];
  points: { id: number; value: number }[];
  setPoints: (points: { id: number; value: number }[]) => void;
};

export const PointDistribution: React.FC<PointDistributionProps> = ({
  question,
  options,
  points,
  setPoints,
}) => {
  const handleSliderChange = (id: number, newValue: number) => {
    const totalPoints = points.reduce((sum, p) => sum + p.value, 0);
    const currentOption = points.find((p) => p.id === id);
    if (!currentOption) return;

    const remainingPoints = 100 - totalPoints + currentOption.value;

    const updatedPoints = points.map((p) =>
      p.id === id ? { ...p, value: Math.min(newValue, remainingPoints) } : p
    );

    setPoints(updatedPoints);
  };

  const totalPoints = points.reduce((sum, p) => sum + p.value, 0);

  return (
    <Box>
      <Typography
        variant="body1"
        gutterBottom
        textAlign={"left"}
        sx={{ mb: 2 }}
      >
        {question}
      </Typography>

      {options.map((option) => {
        const optionValue = points.find((p) => p.id === option.id)?.value || 0;
        return (
          <Box key={option.id} sx={{ marginBottom: 2 }}>
            <Typography variant="body2" color={"grey.600"}>
              {option.text}
            </Typography>
            <Slider
              value={optionValue}
              onChange={(e, newValue) =>
                handleSliderChange(option.id, newValue as number)
              }
              valueLabelDisplay="auto"
              step={1}
              min={0}
              max={100}
            />
          </Box>
        );
      })}
      <Typography
        variant="caption"
        color={"primary"}
        gutterBottom
        textAlign={"left"}
      >
        Toplam Puan: {totalPoints} / 100
      </Typography>
    </Box>
  );
};
